export default "__VITE_ASSET__DufZ5wX0__"